<template>
  <section class="d-flex">
    <div class="text-section">
      <UeInlineEditable
        name="heading"
        :editable="editable"
        v-model="section.heading"
        class="heading font-weight-bold"
        placeholder="Type the title here"
        @editable_field:save="updateName"
      />
      <UeInlineEditable
        :editable="editable"
        v-model="section.body"
        name="body"
        class="body"
        placeholder="Type the text here"
        @editable_field:save="updateBody"
      />
    </div>
    <div class="d-flex align-items-center ml-1">
      <SectionControls
        :case-study-id="caseStudyId"
        :index="index"
        v-if="editable && !isIntroduction"
      />
    </div>
  </section>
</template>
<script>
import SectionMixin from '@app/mixins/case_study_section'
import SectionControls from '@components/case_study_sections/SectionControls.vue'

export default {
  name: 'TextSection',
  components: { SectionControls },
  mixins: [SectionMixin],
  props: {
    caseStudyId: { type: Number, required: true },
    section: { type: Object, required: true },
    index: { type: Number, required: true },
    editable: { type: Boolean, required: false, default: false },
    isIntroduction: { type: Boolean, required: false, default: false },
  },
  methods: {
    updateName(newContent) {
      this.updateByField('heading')(newContent)
    },
    updateBody(newContent) {
      this.updateByField('body')(newContent)
    },
  },
  computed: {
    editableText() {
      // In Vue 3 you have to use null/undefined to make an attribute conditionally
      // not render, false won't work
      return this.editable ? true : null
    },
  },
}
</script>

<style lang="sass" scoped>
.text-section
  padding: 4px
  width: 100%
  overflow: hidden

.delete
  cursor: pointer

.heading
  font-size: 24px
  overflow-wrap: anywhere

.body
  font-size: 18px
  overflow-wrap: anywhere
</style>
